import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {ExportsComponent} from "./exports.component";
import {TmTeamSelectComponent} from "@teammood/team";
 
@NgModule({
  declarations: [
    ExportsComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    TmTeamSelectComponent,
  ]
})
export class TmExportsModule{
}